(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vcprivcat
   * @description
   *
   */
  angular
    .module('vcfinance.privcat', [
    ]);
}());
